import { FC } from 'react'
import Style from '../HallOfFame.module.scss'
import { BitazzaText } from '../../../../../components'
import { Badges } from '../../Badges'
import { getColor } from '../../../../../util/getColor'
import { formatNumber } from '../../../../../util/formatNumber'
import { arrayMove } from '../../../../../util/arrayMethods'

interface Props {
    hallOfFameData: hallOfFame[]
}
export const MonthGroup: FC<Props> = ({ hallOfFameData }) => {
    const data = [...hallOfFameData]
    const top3Data = arrayMove(data, 0, 1)
    return (
        <>
            <div className={Style.rowContainer}>
                {top3Data?.map((item, index) => {
                    return (
                        <div
                            key={index}
                            className={Style.wrapper}
                            style={{
                                backgroundColor:
                                    index === 1 ? '#22224E' : '#13132C',
                            }}
                        >
                            <Badges
                                label={
                                    index === 0 ? item.month_of_rank : undefined
                                }
                                color={getColor(item.pnl_monthly_percent, true)}
                                type={'default'}
                                rank={`${formatNumber(
                                    item.pnl_monthly_percent,
                                    false,
                                    true,
                                    true,
                                    false
                                )}%`}
                                name={`@${item.btz_id}`}
                                highlighted={index === 1}
                                noAvatar
                            />
                            {index === 0 && item.month_of_rank ? (
                                <div
                                    className={Style.labelWrapper}
                                    style={{ top: '-12px' }}
                                >
                                    <BitazzaText
                                        content={item.month_of_rank}
                                        color="#fff"
                                        format="t12"
                                        bold
                                    />
                                </div>
                            ) : null}
                        </div>
                    )
                })}
            </div>
        </>
    )
}
